import EnquiriesManagement from '../EnquiriesManagement';

const FranchiseeEnquiries = () => {
  return <EnquiriesManagement serviceType="franchisee" />;
};

export default FranchiseeEnquiries;